/**
 * @desc 页面banner消息-根据经纬度查询
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** 星际化标识 */
  channel?: string;
  /** 纬度 */
  lat?: string;
  /** 经度 */
  lng?: string;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.HttpResponse>(
    `/storeapi/api/v3/page/banners/location`,
    {
      params,
      method: 'get',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.HttpResponse;
export default req;
